import { useMutation, useQuery } from "@tanstack/react-query";
import {
  EducationalResourcesService,
  EducationalResourcesFindAllPayload,
} from "../services/educationalResources.service";
import { EducationalResourcePayload } from "../domain/educationalResources.interface";

export const useEducationalResources = (
  filters: EducationalResourcesFindAllPayload
) => {
  const {
    data: educationalResources,
    isLoading: isLoadingEducationalResources,
    isFetching: isFetchingEducationalResources,
    refetch: refetchEducationalResources,
  } = useQuery({
    queryKey: ["parca-educational-resources-list"],
    queryFn: () => EducationalResourcesService.findAll(filters),
  });

  return {
    educationalResources,
    isLoadingEducationalResources,
    isFetchingEducationalResources,
    refetchEducationalResources,
  };
};

export const useCreateEducationalResource = () => {
  return useMutation({
    mutationFn: (payload: EducationalResourcePayload) =>
      EducationalResourcesService.createOne(payload),
  });
};

export const useUpdateEducationalResource = () => {
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: EducationalResourcePayload;
    }) => EducationalResourcesService.updateOne({ id, payload }),
  });
};

export const useArchiveEducationalResource = () => {
  return useMutation({
    mutationFn: (id: string) => EducationalResourcesService.archiveOne(id),
  });
};
